import Chart from "chart.js/auto";

export default function (areaId, logicalList, knowledgeList, takeDateList) {
  var ctx = document.getElementById(areaId).getContext("2d");
  var logicalBorderColor = "rgba(24,240,99)";

  var logicalBackgroundColor = "rgba(24,240,99,0.8)";

  var knowledgeBorderColor = "rgba(255,137,0)";

  var knowledgeBackGroundColor = "rgba(255,137,0,0.8)";

  var knowledge = knowledgeList;
  //知識データ
  var logical = logicalList;
  //論理データ
  var date = takeDateList;

  //ラベルの色
  Chart.defaults.color = "#fff";

  //日時のデータ（X軸）
  var myAreaChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: date,
      datasets: [
        {
          label: "論理",
          data: logical,
          borderColor: logicalBorderColor,
          backgroundColor: logicalBackgroundColor,
          tension: 0,
        },
        {
          label: "知識",
          data: knowledge,
          borderColor: knowledgeBorderColor,
          backgroundColor: knowledgeBackGroundColor,
          tension: 0,
        },
      ],
    },
    plugins: [
      {
        id: "custom_vertical_lines",
        afterDatasetsDraw: function (chart, ease) {
          const {
            ctx,
            scales: { x, y },
          } = chart;
          for (var i = 1; i < date.length - 1; i++) {
            if (date[i] != "") {
              // カスタム描画を追加でおこなうため、データセットのメタデータを取得
              var meta = chart.getDatasetMeta(0);
              var data = meta.data;
              // X座標
              var xPos = data[i].x;
              // Y座標
              var y_top = y.top;
              var y_bottom = y.bottom;

              // 垂直線の描画
              ctx.save();
              ctx.beginPath();
              ctx.lineWidth = 2;
              ctx.strokeStyle = "#FFF";
              ctx.moveTo(xPos, y_top);
              ctx.lineTo(xPos, y_bottom);
              ctx.stroke();
              ctx.restore();
            }
          }
        },
      },
    ],
    options: {
      plugins: {
        title: {
          display: true,
          text: "経験値量",
          color: "white",
        },
        legend: {
          display: true,
        },
      },
      scales: {
        x: {
          // Ｘ軸設定
          title: {
            // 軸ラベル
            display: true, // 表示設定
            color: "#fff", // 文字の色
          },
          grid: {
            // 補助線
            color: "rgba(255,255,255,0.2)", // 補助線の色
          },
          ticks: {
            // 目盛り
            color: "white", // 目盛りの色
          },
        },
        y: {
          // Ｙ軸設定
          stacked: true, //積み上げにする
          suggestedMin: 0,
          ticks: {
            color: "white", // 目盛りの色
          },
          grid: {
            // 補助線
            color: "white", // 補助線の色
          },
        },
      },
    },
  });
}
